"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _classnames = _interopRequireDefault(require("classnames"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _ShareInput = _interopRequireDefault(require("../../decorators/ShareInput"));

var _Functions = require("../../core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("../../core/SyntheticEvent"));

var _refObject = _interopRequireDefault(require("../../utils/propTypes/refObject"));

var RenderProp = _interopRequireWildcard(require("../../utils/propTypes/renderProp"));

var _OptionTypes = require("../../types/OptionTypes");

var _PlacementConstants = require("../../tooltip/PlacementConstants");

var _UIAbstractDropdownWithSearchbox = _interopRequireDefault(require("../../dropdown/abstract/UIAbstractDropdownWithSearchbox"));

var _UITypeaheadSearch = _interopRequireDefault(require("../../typeahead/search/UITypeaheadSearch"));

var _UITag = _interopRequireDefault(require("../../tag/UITag"));

var _SelectOptionUtils = require("../utils/SelectOptionUtils");

var _Props = require("../../utils/Props");

var DISPLAY_NONE_STYLE = {
  display: 'none'
};
var buttonContentPropTypes = {
  buttonText: _propTypes.default.node.isRequired
};

var noop = function noop() {};

var getEventProps = function getEventProps(props) {
  var eventPropKeyRegex = /^on[A-Z]/;
  return Object.keys(props).filter(function (key) {
    return key !== 'onClose' && key !== 'onInputChange' && key !== 'onInputKeyDown' && key !== 'onOpen' && key !== 'onInputValueChange';
  }).reduce(function (acc, key) {
    if (!key) return acc;

    if (key.match(eventPropKeyRegex)) {
      acc[key] = props[key];
    }

    return acc;
  }, {});
};

var UISelectWithButtonAnchor = (0, _createReactClass.default)({
  displayName: 'UISelectWithButtonAnchor',
  propTypes: {
    autoComplete: _propTypes.default.string,
    autoFocus: _propTypes.default.bool,
    autoload: _propTypes.default.bool,
    ButtonContent: RenderProp.getPropType({
      propTypes: buttonContentPropTypes
    }),
    buttonSize: _UIAbstractDropdownWithSearchbox.default.propTypes.buttonSize,
    buttonStyle: _propTypes.default.object,
    buttonUse: _UIAbstractDropdownWithSearchbox.default.propTypes.buttonUse,
    cache: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]),
    caretRenderer: _UIAbstractDropdownWithSearchbox.default.propTypes.caretRenderer,
    closeOnOutsideClick: _UIAbstractDropdownWithSearchbox.default.propTypes.closeOnOutsideClick,
    closeOnTargetLeave: _UIAbstractDropdownWithSearchbox.default.propTypes.closeOnTargetLeave,
    disabled: _propTypes.default.bool,
    dropdownClassName: _propTypes.default.string,
    dropdownContentRef: _propTypes.default.func,
    dropdownFooter: _propTypes.default.node,
    error: _propTypes.default.bool,
    initiallyOpen: _propTypes.default.bool.isRequired,
    inputRef: _refObject.default.isRequired,
    menuWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
    minimumSearchCount: _propTypes.default.number,
    multi: _propTypes.default.bool,
    isOpen: _propTypes.default.bool.isRequired,
    loadOptions: _propTypes.default.func,
    onChange: _propTypes.default.func,
    onInputValueChange: _propTypes.default.func,
    onOpenChange: _propTypes.default.func,
    options: _propTypes.default.arrayOf(_OptionTypes.OptionOrGroupType),
    placeholder: _propTypes.default.node,
    placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS),
    readOnly: _propTypes.default.bool,
    resetOption: _OptionTypes.OptionType.isRequired,
    resetValue: _OptionTypes.ValueType,
    resultsClassName: _propTypes.default.string,
    searchable: _propTypes.default.bool,
    searchClassName: _propTypes.default.string,
    SearchInput: _propTypes.default.elementType,
    searchPlaceholder: _propTypes.default.string,
    selectComponent: _propTypes.default.func.isRequired,
    selectRef: _propTypes.default.func,
    value: _propTypes.default.any,
    valueRenderer: _propTypes.default.func,
    _forcePlaceholder: _propTypes.default.bool
  },
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({}, _UIAbstractDropdownWithSearchbox.default.defaultProps, {
      searchable: true
    });
  },
  getInitialState: function getInitialState() {
    return {
      inputCache: {},
      inputValue: '',
      searchCount: 0
    };
  },
  componentDidMount: function componentDidMount() {
    var _this$props = this.props,
        autoload = _this$props.autoload,
        cache = _this$props.cache,
        isOpen = _this$props.isOpen,
        loadOptions = _this$props.loadOptions,
        selectComponent = _this$props.selectComponent; // Mount a separate Select.Async instance to perform autoload, if needed. This is a weird hack,
    // but a necessary one since the normal Select isn't mounted until the user opens the dropdown.

    if (autoload && loadOptions && !isOpen) {
      this._autoloadSelectEl = document.createElement('div');
      var SelectComponent = selectComponent;

      _reactDom.default.render(_react.default.createElement(SelectComponent, {
        autoload: autoload,
        cache: typeof cache === 'undefined' ? this.state.inputCache : cache,
        loadOptions: loadOptions
      }), this._autoloadSelectEl);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._autoloadSelectEl) {
      _reactDom.default.unmountComponentAtNode(this._autoloadSelectEl);

      this._autoloadSelectEl = null;
    }
  },
  focus: function focus() {
    var _this$props2 = this.props,
        onOpenChange = _this$props2.onOpenChange,
        isOpen = _this$props2.isOpen;
    if (!isOpen) onOpenChange((0, _SyntheticEvent.default)(true));
  },
  selectRefCallback: function selectRefCallback(ref) {
    var selectRef = this.props.selectRef; // When react-select mounts, ask it how many (flattened) options it has

    this._selectRef = ref;
    var internalSelect = this.getInternalSelect();

    if (internalSelect) {
      this.setState({
        searchCount: internalSelect._flatOptions.length
      });
    }

    if (selectRef) {
      selectRef(ref);
    }
  },
  getInternalSelect: function getInternalSelect() {
    // Return our react-select component instance, or null
    if (!this._selectRef) {
      return null;
    }

    if (!this._selectRef.select) {
      return this._selectRef;
    } // _selectRef must be an <Async> or <Creatable> wrapper


    return this._selectRef.select;
  },
  getInternalAsyncSelect: function getInternalAsyncSelect() {
    // Return our react-select Async instance, or null
    if (!this._selectRef || !this._selectRef.select) {
      return null;
    }

    return this._selectRef;
  },
  handleInputKeyDown: function handleInputKeyDown(evt) {
    var _this = this;

    var internalSelect = this.getInternalSelect();

    if (internalSelect) {
      internalSelect.handleKeyDown(evt);
      setTimeout(function () {
        _this.forceUpdate(); // Ensure that the input renders with updated ARIA attrs on up/down

      });
    }
  },
  handleInputChange: function handleInputChange(evt) {
    var onInputValueChange = this.props.onInputValueChange;
    (0, _Functions.callIfPossible)(onInputValueChange, evt);
    var internalSelect = this.getInternalSelect();

    if (internalSelect) {
      internalSelect.handleInputChange(evt);
    } // This setState() forces an update, ensuring that Tether is repositioned properly.


    this.setState({
      inputValue: evt.target.value
    });
  },
  handleInputFocus: function handleInputFocus() {
    // React Select thinks it's closed when its input receives a blur event.
    // We don't want that, because it ignores keydown events when closed.
    var internalSelect = this.getInternalSelect();

    if (internalSelect) {
      internalSelect.setState({
        isOpen: true
      });
    }
  },
  handleFocusLeave: function handleFocusLeave() {// Temporarily disabled. This causes close-and-reopen when clicking the anchor.
    // const { onOpenChange } = this.props;
    // onOpenChange(SyntheticEvent(false));
  },
  handleRemoveValueClick: function handleRemoveValueClick(optionValue, evt) {
    var _this2 = this;

    var _this$props3 = this.props,
        onChange = _this$props3.onChange,
        value = _this$props3.value;
    var internalSelect = this.getInternalSelect();

    if (internalSelect) {
      var internalSelectValueArray = internalSelect.getValueArray(internalSelect.props.value);
      internalSelect.setValue(internalSelectValueArray.filter(function (option) {
        return option.value !== optionValue;
      }));
    } else {
      // Select is unmounted (e.g. because the dropdown is closed), so we handle the change
      // ourselves. Note that the "value" prop on UISelectWithButtonAnchor is an array of options.
      var allOptions = (value || []).map(function (v) {
        return (0, _typeof2.default)(v) === 'object' ? v : _this2.getOptionForSingleValue(v);
      });
      var newOptions = allOptions.filter(function (v) {
        return v.value !== optionValue;
      });
      onChange(newOptions);
    }

    evt.stopPropagation(); // Prevent dropdown toggle
  },
  hasSearchbox: function hasSearchbox(_ref) {
    var loadOptions = _ref.loadOptions,
        minimumSearchCount = _ref.minimumSearchCount,
        searchable = _ref.searchable;

    // No search, no searchbox.
    if (!searchable) {
      return false;
    } // If we're in async mode, always show the searchbox. Otherwise, show it only if the number of
    // (flattened) options meets minimumSearchCount, or if a search has been entered.


    return !!loadOptions || this.state.searchCount >= minimumSearchCount || Boolean(this.state.inputValue);
  },
  getOptionForSingleValue: function getOptionForSingleValue(singleValue) {
    var options = this.props.options; // If the given "value" is actually an option, return it as-is.

    if ((0, _typeof2.default)(singleValue) === 'object' && singleValue.value) {
      return singleValue;
    } // If the given value maps to an option, return that.


    var option = (0, _SelectOptionUtils.getValueOption)(options, singleValue);

    if (option) {
      return option;
    } // Otherwise, return a new option with the given value.


    return {
      text: singleValue,
      value: singleValue
    };
  },
  getButtonContent: function getButtonContent(_ref2) {
    var disabled = _ref2.disabled,
        readOnly = _ref2.readOnly,
        loadOptions = _ref2.loadOptions,
        multi = _ref2.multi,
        options = _ref2.options,
        placeholder = _ref2.placeholder,
        resetOption = _ref2.resetOption,
        resetValue = _ref2.resetValue,
        value = _ref2.value,
        valueRenderer = _ref2.valueRenderer,
        _forcePlaceholder = _ref2._forcePlaceholder;

    if (_forcePlaceholder) {
      return {
        valueIsValid: true,
        buttonText: placeholder
      };
    }

    if (multi) {
      var renderedMultiValues = this.renderMultiValues({
        disabled: disabled,
        readOnly: readOnly,
        placeholder: placeholder,
        value: value,
        valueRenderer: valueRenderer
      });
      return {
        valueIsValid: true,
        buttonText: _react.default.createElement("span", {
          className: (0, _classnames.default)('private-form__selectplus--multi-values', {
            'has-value-tags': Array.isArray(renderedMultiValues)
          })
        }, renderedMultiValues)
      };
    }

    return (0, _SelectOptionUtils.getButtonProps)({
      async: !!loadOptions,
      options: options,
      placeholder: placeholder,
      resetOption: resetOption,
      resetValue: resetValue,
      value: value,
      valueRenderer: valueRenderer
    });
  },
  renderMultiValues: function renderMultiValues(_ref3) {
    var _this3 = this;

    var disabled = _ref3.disabled,
        readOnly = _ref3.readOnly,
        placeholder = _ref3.placeholder,
        value = _ref3.value,
        valueRenderer = _ref3.valueRenderer;

    if (!Array.isArray(value) || value.length === 0) {
      return placeholder;
    }

    return value.map(function (v) {
      var option = _this3.getOptionForSingleValue(v);

      var handleCloseClick = _this3.handleRemoveValueClick.bind(_this3, option.value);

      return _react.default.createElement(_UITag.default, {
        _bordered: true,
        closeable: !disabled && !readOnly && option.clearableValue !== false,
        key: option.value,
        onCloseClick: handleCloseClick,
        use: option.tagUse || 'default'
      }, valueRenderer(option));
    });
  },
  renderSearch: function renderSearch(_ref4, _ref5) {
    var autoComplete = _ref4.autoComplete,
        initiallyOpen = _ref4.initiallyOpen,
        inputRef = _ref4.inputRef,
        onPaste = _ref4.onPaste,
        searchClassName = _ref4.searchClassName,
        SearchInput = _ref4.SearchInput,
        searchPlaceholder = _ref4.searchPlaceholder;
    var hasSearchbox = _ref5.hasSearchbox;
    var ariaActiveDescendant;
    var ariaOwns;
    var internalSelect = this.getInternalSelect();

    if (internalSelect) {
      var valueArray = internalSelect.getValueArray(internalSelect.props.value);
      ariaActiveDescendant = internalSelect._instancePrefix + "-option-" + internalSelect.getFocusableOptionIndex(valueArray[0]);
      ariaOwns = internalSelect._instancePrefix + "--list";
    }

    return _react.default.createElement(_UITypeaheadSearch.default, {
      "aria-activedescendant": ariaActiveDescendant,
      "aria-owns": ariaOwns,
      autoComplete: autoComplete,
      autoFocus: !initiallyOpen,
      className: (0, _classnames.default)(searchClassName, {
        'sr-only': !hasSearchbox
      }),
      Input: SearchInput,
      inputRef: inputRef,
      onKeyDown: this.handleInputKeyDown,
      onChange: this.handleInputChange,
      onFocus: this.handleInputFocus,
      onPaste: onPaste,
      placeholder: searchPlaceholder,
      role: "combobox"
    });
  },
  render: function render() {
    var _this$props4 = this.props,
        autoComplete = _this$props4.autoComplete,
        autoFocus = _this$props4.autoFocus,
        ButtonContent = _this$props4.ButtonContent,
        buttonSize = _this$props4.buttonSize,
        buttonStyle = _this$props4.buttonStyle,
        buttonUse = _this$props4.buttonUse,
        cache = _this$props4.cache,
        caretRenderer = _this$props4.caretRenderer,
        className = _this$props4.className,
        closeOnOutsideClick = _this$props4.closeOnOutsideClick,
        closeOnTargetLeave = _this$props4.closeOnTargetLeave,
        disabled = _this$props4.disabled,
        dropdownClassName = _this$props4.dropdownClassName,
        dropdownContentRef = _this$props4.dropdownContentRef,
        dropdownFooter = _this$props4.dropdownFooter,
        error = _this$props4.error,
        id = _this$props4.id,
        initiallyOpen = _this$props4.initiallyOpen,
        inputRef = _this$props4.inputRef,
        isOpen = _this$props4.isOpen,
        loadOptions = _this$props4.loadOptions,
        menuWidth = _this$props4.menuWidth,
        minimumSearchCount = _this$props4.minimumSearchCount,
        multi = _this$props4.multi,
        onChange = _this$props4.onChange,
        onPaste = _this$props4.onPaste,
        options = _this$props4.options,
        placeholder = _this$props4.placeholder,
        placement = _this$props4.placement,
        readOnly = _this$props4.readOnly,
        resetValue = _this$props4.resetValue,
        searchClassName = _this$props4.searchClassName,
        searchPlaceholder = _this$props4.searchPlaceholder,
        resetOption = _this$props4.resetOption,
        resultsClassName = _this$props4.resultsClassName,
        searchable = _this$props4.searchable,
        SearchInput = _this$props4.SearchInput,
        selectComponent = _this$props4.selectComponent,
        __selectRef = _this$props4.selectRef,
        value = _this$props4.value,
        valueRenderer = _this$props4.valueRenderer,
        _forcePlaceholder = _this$props4._forcePlaceholder,
        rest = (0, _objectWithoutProperties2.default)(_this$props4, ["autoComplete", "autoFocus", "ButtonContent", "buttonSize", "buttonStyle", "buttonUse", "cache", "caretRenderer", "className", "closeOnOutsideClick", "closeOnTargetLeave", "disabled", "dropdownClassName", "dropdownContentRef", "dropdownFooter", "error", "id", "initiallyOpen", "inputRef", "isOpen", "loadOptions", "menuWidth", "minimumSearchCount", "multi", "onChange", "onPaste", "options", "placeholder", "placement", "readOnly", "resetValue", "searchClassName", "searchPlaceholder", "resetOption", "resultsClassName", "searchable", "SearchInput", "selectComponent", "selectRef", "value", "valueRenderer", "_forcePlaceholder"]);

    var _this$getButtonConten = this.getButtonContent({
      disabled: disabled,
      readOnly: readOnly,
      loadOptions: loadOptions,
      multi: multi,
      options: options,
      placeholder: placeholder,
      resetOption: resetOption,
      resetValue: resetValue,
      value: value,
      valueRenderer: valueRenderer,
      _forcePlaceholder: _forcePlaceholder
    }),
        buttonText = _this$getButtonConten.buttonText,
        valueIsValid = _this$getButtonConten.valueIsValid;

    var hasSearchbox = this.hasSearchbox({
      loadOptions: loadOptions,
      minimumSearchCount: minimumSearchCount,
      searchable: searchable
    });
    var SelectComponent = selectComponent;
    return _react.default.createElement(_UIAbstractDropdownWithSearchbox.default, (0, _extends2.default)({}, (0, _Props.getAriaAndDataProps)(rest), getEventProps(rest), {
      _useNativeButton: false,
      "aria-invalid": error != null ? error : !valueIsValid,
      autoFocus: autoFocus,
      buttonText: ButtonContent == null ? buttonText : _react.default.createElement(ButtonContent, {
        buttonText: buttonText
      }),
      buttonSize: buttonSize,
      buttonUse: buttonUse,
      caretRenderer: caretRenderer,
      className: className,
      closeOnOutsideClick: closeOnOutsideClick,
      closeOnTargetLeave: closeOnTargetLeave,
      disabled: disabled,
      dropdownClassName: dropdownClassName,
      dropdownContentRef: dropdownContentRef,
      hasSearchbox: hasSearchbox,
      id: id,
      menuWidth: menuWidth,
      multiline: multi,
      onFocusLeave: this.handleFocusLeave,
      onOpenComplete: this.handleOpenComplete,
      open: isOpen,
      placement: placement,
      readOnly: readOnly,
      style: buttonStyle
    }), this.renderSearch({
      autoComplete: autoComplete,
      initiallyOpen: initiallyOpen,
      inputRef: inputRef,
      onPaste: onPaste,
      searchClassName: searchClassName,
      SearchInput: SearchInput,
      searchPlaceholder: searchPlaceholder
    }, {
      hasSearchbox: hasSearchbox
    }), _react.default.createElement("span", {
      className: (0, _classnames.default)('private-typeahead-results', resultsClassName),
      "data-dropdown-results": true
    }, _react.default.createElement(SelectComponent, (0, _extends2.default)({}, rest, {
      autosize: false,
      cache: typeof cache === 'undefined' ? this.state.inputCache : cache,
      disabled: disabled,
      isOpen: true,
      loadOptions: loadOptions,
      multi: multi,
      onChange: onChange,
      options: options,
      readOnly: readOnly,
      ref: this.selectRefCallback,
      resetValue: resetValue,
      scrollMenuIntoView: false,
      style: DISPLAY_NONE_STYLE,
      tabIndex: "-1",
      value: value,
      valueRenderer: noop
    }))), dropdownFooter);
  }
});

var _default = (0, _ShareInput.default)(UISelectWithButtonAnchor);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/input/internal/UISelectWithButtonAnchor.js
// module id = 740
// module chunks = 209 210 211 212